import clsx from 'clsx';

import { Tooltip } from 'shared/ui/tooltip';
import { eventService, getPage, XApiEventKeys } from 'shared/api/event-service';

import styles from './styles.module.scss';

export type SectionInfoProps = {
  messageText: string;
  sectionName:
    | 'stream'
    | 'scheduled'
    | 'recommendations'
    | 'recently-visited-locations';
  tooltipClassnames?: string;
};

export const SectionInfo = ({
  messageText,
  sectionName,
  tooltipClassnames,
}: SectionInfoProps) => {
  const handleXApiEvents = (isRightClick: boolean) => {
    eventService.send(XApiEventKeys.sectionInfoHovered, undefined, {
      result: {
        url: window.location.href,
        page: getPage(),
        section: sectionName,
        isRightClick,
      },
    });
  };

  const handleMouseEnter = () => handleXApiEvents(false);

  const handleContextMenu = () => handleXApiEvents(true);

  return (
    <div onMouseEnter={handleMouseEnter} onContextMenu={handleContextMenu}>
      <Tooltip
        title={messageText}
        wrapperClassNames={styles.tooltipWrapper}
        tooltipClassNames={clsx(styles.tooltipContent, tooltipClassnames)}
        showOnHover={false}
        showCloseIcon
      >
        <button
          type="button"
          className={clsx('btn btn-icon-ghost', styles.infoIconButton)}
        >
          <i className="icon-v2-information" aria-hidden />
        </button>
      </Tooltip>
    </div>
  );
};
